import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getSoilDepthCatalog = state => state.models[name].data;
export const getCurSoilDepth = state => state.models[name].item;